<template>
<toggle opened="less">
    <toggle-content name="less">
        <toggle-trigger name="more">
            <text-link>
                Recorder
            </text-link>
        </toggle-trigger>
    </toggle-content>

    <toggle-content name="more">
        <text-link @click="play">
            <icon>play_arrow</icon>
            play
        </text-link>

        <text-link v-if="!recording" @click="record">
            <icon color="error" key="record">brightness_1</icon>
            record
        </text-link>

        <text-link v-else @click="recording = false">
            <icon key="stop">stop</icon>
            stop
        </text-link>

        <text-link v-if="!recording && list.length" @click="copy">
            <icon>content_copy</icon>
            copy
        </text-link>
    </toggle-content>
</toggle>

</template>

<script>
import { qaBus } from '@/utils/qa-bus';
import { copyText } from '../utils/clipboard';
import { showNotifier, hideNotifier } from '../utils/notifier';
import Vue from 'vue';

export default Vue.extend({
    components: {
        'text-link': require('@clearwave/odoro-markup/lib/vue/text-link.vue').default,
        toggle: require('@clearwave/odoro-markup/lib/vue/toggle.vue').default,
        icon: require('@clearwave/odoro-markup/lib/vue/icon.vue').default,
        'toggle-trigger': require('@clearwave/odoro-markup/lib/vue/toggle-trigger.vue').default,
        'toggle-content': require('@clearwave/odoro-markup/lib/vue/toggle-content.vue').default,
    },
    data () {
        return {
            list: [],
            recording: false,
            prevEventTS: 0,
        };
    },
    mounted () {
        qaBus.$on('stepAnswer', (data) => {
            if (this.recording) {
                this.list.push({
                    stepAnswer: data,
                });
                console.log('answered:', data);
            }
        });

        ['click', 'input', 'hover', 'mousewheel'].forEach(type => {
            window.addEventListener(type, (event) => {
                if (event.target === window || !this.recording) {
                    return;
                }
                let dataQa = event.target && (event.target.getAttribute('data-qa') || event.target.getAttribute('data-qa-recoroder')) ? event.target : (event.target?.closest('[data-qa-recorder]') || event.target?.closest('[data-qa]'));
                if (dataQa) {
                    let value = event.target?.value;
                    let target = dataQa?.getAttribute('data-qa-recorder') || dataQa?.getAttribute('data-qa');
                    let type = event.type;
                    this.list.push({
                        value,
                        constructor: event.constructor.name,
                        target,
                        type,
                        timeDelta: Date.now() - this.prevEventTS,
                    });
                    this.prevEventTS = Date.now();
                    console.log(`recorderd: ${type}, ${target}`);
                }
            });
        });

        window.__odrRecorded = entry => {
            this.list = [...entry];
            this.play();
        };
    },
    methods: {
        record () {
            this.list = [];
            this.recording = true;
            this.prevEventTS = Date.now();
        },
        copy () {
            copyText(`window.__odrRecorded(${JSON.stringify(this.list)});`);
            showNotifier({
                stateId: `general:${this.$root.id}`,
                icon: 'warning',
                title: 'Record copied to clipboard',
                autoHide: true,
                buttons: [
                    {
                        title: 'close',
                        handler: () => {
                            hideNotifier(`general:${this.$root.id}`);
                        },
                    },
                ],
            });
        },
        play () {
            let list = [...this.list];

            let awaitSelector = ({ selector, timeout = 3000, onsuccess, onerror, sleep = 200 }) => {
                let timer;
                let interval = setInterval(() => {
                    let element = document.querySelector(selector);
                    if (element) {
                        onsuccess(element);
                        clearTimeout(timer);
                        clearInterval(interval);
                    }
                }, sleep);

                timer = setTimeout(() => {
                    clearInterval(interval);
                    console.error(`awaiting for selector ${selector} timed out`);
                    onerror();
                }, timeout);
            };

            this.recording = false;

            let runEvent = event => {
                if (!event) { return; }
                if (event.stepAnswer) {
                    runEvent(list.shift());
                    return;
                }
                awaitSelector({
                    selector: `[data-qa="${event.target}"],[data-qa-recorder="${event.target}"]`,
                    onsuccess: element => {
                        if (event.constructor === InputEvent.name) {
                            element.value = event.value;
                        }

                        element.dispatchEvent(new window[event.constructor](event.type));

                        runEvent(list.shift());
                    },
                    onerror: () => {},
                    sleep: event.timeDelta,
                });
            };

            runEvent(list.shift());
        },
    },
});
</script>
